export default {
  friends: {
    title: '好友',
    subtitle: '管理你的好友關係',
    addFriend: '新增好友',
    noFriends: '還沒有好友',
    addFriendsHint: '新增好友一起記帳吧！',
    unknownUser: '未知用戶',
    removeFriend: '刪除好友',
    confirmRemove: '確認刪除好友？',
    removeSuccess: '好友刪除成功',
    removedFriend: '已刪除好友 {name}',
    
    // 標籤
    tagsUpdated: '朋友標籤已更新',
    allFriends: '全部',
    noTaggedFriends: '暫無"{tag}"標籤的朋友',
    tryOtherTags: '嘗試選擇其他標籤或新增朋友',
    
    // 載入狀態
    loading: {
      title: '連繫好友中...',
      subtitle: '正在為你載入好友資訊',
    },
    // 標籤編輯器
    editTags: '編輯朋友標籤',
    selectedTags: '已選標籤',
    presetTags: '預設標籤',
    myTags: '我的標籤',
    addCustomTag: '新增自訂標籤',
    tagInputPlaceholder: '輸入標籤名稱（如：健身夥伴）',
    tagHelp: '標籤幫助',
    tagAlreadyExists: '該標籤已存在',
    tagSaveSuccess: '朋友標籤更新成功',
    tagSaveError: '儲存失敗',
    saving: '儲存中...',
    save: '儲存',
    noTagsSelected: '未選擇標籤',
    success: '成功',
    error: '錯誤',
    tagHelpText: `• 標籤可以幫助你分類管理朋友
• 創建聚餐時可以通過標籤快速選擇邀請對象
• 一個朋友可以擁有多个標籤
• 建議使用簡短明確的標籤名稱`,
    
    // 預設標籤翻譯
    presetTagCoworker: '同事',
    presetTagClassmate: '同學', 
    presetTagNeighbor: '鄰居',
    presetTagRoommate: '室友',
    presetTagFamily: '家人',
    presetTagGymBuddy: '健身夥伴',
    presetTagGameBuddy: '遊戲夥伴',
    presetTagLunchBuddy: '午餐夥伴',
    presetTagTravelBuddy: '旅行夥伴',
    presetTagStudyBuddy: '學習夥伴',
    presetTagWorkPartner: '工作夥伴',
    
    // 搜尋和新增
    contactLabel: '聯繫方式',
    contactPlaceholder: '輸入信箱、用戶名或手機號',
    searchPlaceholder: '搜尋用戶名、信箱或手機號',
    searchEmpty: '沒有找到用戶',
    searchError: '搜尋失敗，請稍後重試',
    searchHint: '輸入完整資訊以獲得更準確的搜尋結果',
    searching: '搜尋中...',
    searchResults: '搜尋結果',
    addByContact: '透過聯繫方式新增',
    scanQRCode: '掃描二維碼新增',
    shareMyQR: '分享我的二維碼',
    sendRequest: '發送好友請求',
    
    // 好友請求訊息
    messageLabel: '好友請求訊息（可選）',
    messagePlaceholder: '介紹一下自己，讓對方更容易接受你的好友請求',
    
    // 訊息提示
    loadFailed: '載入好友列表失敗',
    searchFailed: '搜尋失敗',
    incompleteUserInfo: '用戶資訊不完整',
    enterContactInfo: '請輸入信箱、用戶名或手機號',
    requestSent: '好友請求發送成功！',
    requestFailed: '發送好友請求失敗',
    removeFailed: '刪除好友失敗',
  }
};